(function () {
  'use strict';

  angular.module('lead.bulk.status', ['ngResource']);
})();
